import { ThingStatus } from './thingStatus';
import { ThingControl } from './thingControl';
export class ThingAccessories {
    macID: string;
    ipAddress: string;
    accessoryIdentifier: string;
    thingName: string;
    roomName: string;
    statusList: Array<ThingStatus>;
    thingControl: Array<ThingControl>;
    accessoryType: string;
    isLinkingAvailable: boolean;
    canChangeType: boolean;
    linkingMacId: string;
    removeLinkingMacId: string;
    isLinkableThing: boolean;
    constructor(macID: string,
        ipAddress: string,
        accessoryIdentifier: string,
        thingName: string,
        roomName: string,
        statusList: Array<ThingStatus>,
        thingControl: Array<ThingControl>,
        accessoryType: string,
        isLinkingAvailable: boolean,
        canChangeType: boolean,
        linkingMacId: string,
        removeLinkingMacId: string,
        isLinkableThing: boolean) {
        this.macID = macID;
        this.ipAddress = ipAddress;
        this.accessoryIdentifier = accessoryIdentifier;
        this.thingName = thingName;
        this.roomName = roomName;
        this.statusList = statusList;
        this.thingControl = thingControl;
        this.accessoryType = accessoryType;
        this.isLinkingAvailable = isLinkingAvailable;
        this.canChangeType = canChangeType;
        this.linkingMacId = linkingMacId;
        this.removeLinkingMacId = removeLinkingMacId;
        this.isLinkableThing = isLinkableThing;
    }
}